import { render, staticRenderFns } from "./UserInformationForm.vue?vue&type=template&id=9244085a&"
import script from "./UserInformationForm.vue?vue&type=script&lang=js&"
export * from "./UserInformationForm.vue?vue&type=script&lang=js&"
import style0 from "./UserInformationForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports